"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationReducer = void 0;
const configuration_component_1 = __importDefault(require("./configuration.component"));
const configuration_reducer_1 = __importDefault(require("./configuration.reducer"));
exports.configurationReducer = configuration_reducer_1.default;
exports.default = configuration_component_1.default;
